// Auto-generated from 1d.json - patterns as RLE
const patterns = {
  'default': {
    'Garden of Eden 101': {
      rle: 'x = 3, y = 1\n3o!',
      description: 'The simplest Garden of Eden configuration (101) - has no predecessor',
    },
    'Glider': {
      rle: 'x = 5, y = 1\nob3o!',
      description: 'Simple glider pattern with 4 cells in a line. Creates moving patterns in 1D automaton.',
    },
    '1/3 Glider': {
      rle: 'x = 8, y = 1\nob6o!',
      description: '1/3 density glider pattern with 7 cells. Creates moving patterns with 1/3 cell density.',
    },
    'Spider': {
      rle: 'x = 6, y = 1\n6o!',
      description: 'Six active cells arranged in a spider-like pattern. Creates interesting web-like formations.',
    },
  },
};
export default patterns;
